import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth/user/$slug")({
  head: () => appTitleHead("not-found-title"),
  component: AccountUserPage
});

/** Demo page — API route removed in CSR migration. */
function AccountUserPage() {
  const { slug } = Route.useParams();

  return (
    <div className="p-4">
      <h1 className="text-lg font-semibold">User: {slug}</h1>
      <p className="text-muted-foreground text-sm">
        This demo route is not available in the SPA build.
      </p>
      <NotFoundPage />
    </div>
  );
}
